import React, { useState, useEffect } from 'react';
import { 
  CheckCircleIcon, 
  ExclamationTriangleIcon, 
  InformationCircleIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const UpdateNotification = ({ message, type = 'info', onClose, autoHide = true }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (autoHide && type !== 'error') {
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose && onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [autoHide, type, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    onClose && onClose();
  };

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon className="w-5 h-5 text-green-400" />;
      case 'error':
        return <ExclamationTriangleIcon className="w-5 h-5 text-red-400" />;
      case 'warning':
        return <ExclamationTriangleIcon className="w-5 h-5 text-yellow-400" />;
      default:
        return <InformationCircleIcon className="w-5 h-5 text-blue-400" />;
    }
  };

  const getBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-900/20 border-green-700';
      case 'error':
        return 'bg-red-900/20 border-red-700';
      case 'warning':
        return 'bg-yellow-900/20 border-yellow-700';
      default:
        return 'bg-blue-900/20 border-blue-700';
    }
  };

  return (
    <div className={`fixed top-4 right-4 z-50 max-w-sm w-full ${getBgColor()} border rounded-lg p-4 shadow-lg`}>
      <div className="flex items-start gap-3">
        {getIcon()}
        <div className="flex-1">
          <p className="text-sm text-dark-text font-medium">
            {type === 'success' && 'Atualização Concluída'}
            {type === 'error' && 'Erro na Atualização'}
            {type === 'warning' && 'Aviso'}
            {type === 'info' && 'Informação'}
          </p>
          <p className="text-sm text-dark-text-secondary mt-1">
            {message}
          </p>
        </div>
        <button
          onClick={handleClose}
          className="text-dark-text-secondary hover:text-dark-text transition-colors"
        >
          <XMarkIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default UpdateNotification;
